/* global window */
/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(function ($) {

    // Seksjonene toner inn når de rulles i bildet. Selve bevegelsen ligger i
    // CSS-en (_sections.scss); her holdes bare rede på hva som er kommet fram.
    //
    // IntersectionObserver og ikke GSAP: biblioteket lastes bare på langlesing,
    // og å dra det inn på hele nettstedet for en innton-effekt er feil bytte.
    //
    // Langlesing-artiklene har ingen .modul — de bygges av content-parallax.php
    // med sine egne komponenter — så de er naturlig utenfor og beholder sin
    // egen GSAP-koreografi.
    (function () {
        var seksjoner = document.querySelectorAll('.grid-container.modul, .grid-container.accordions');
        if (!seksjoner.length || !window.IntersectionObserver) { return; }

        // Hvor langt inn i bildet overkanten må være før en seksjon regnes som
        // framme. Samme tall brukes to steder under, så grensa for «allerede
        // synlig ved lasting» og for «rullet fram» er den samme.
        var NEDRE_MARG = 80;

        var observatør = new IntersectionObserver(function (oppføringer) {
            oppføringer.forEach(function (oppføring) {
                if (!oppføring.isIntersecting) { return; }
                oppføring.target.classList.add('er-fremme');
                // Enveis: en seksjon som er vist skal ikke animeres om igjen
                // når du ruller opp forbi den.
                observatør.unobserve(oppføring.target);
            });
        }, {
            // Terskel i prosent svikter på seksjoner som er høyere enn skjermen
            // — de blir aldri «25 % synlige». Her fyrer det i stedet når
            // overkanten er et stykke inne i bildet, uansett hvor høy
            // seksjonen er.
            threshold: 0,
            rootMargin: '0px 0px -' + NEDRE_MARG + 'px 0px'
        });

        Array.prototype.forEach.call(seksjoner, function (seksjon) {
            var boks = seksjon.getBoundingClientRect();

            // Er seksjonen allerede i bildet når sida lastes, skal den bare stå
            // der — ikke tone inn. «uten-overgang» er nødvendig fordi CSS-en
            // allerede har tegnet den skjulte tilstanden; uten den ville
            // klassen utløst en innton-animasjon i stedet for å hoppe over den.
            if (boks.top < window.innerHeight - NEDRE_MARG && boks.bottom > 0) {
                seksjon.classList.add('uten-overgang', 'er-fremme');
                return;
            }

            observatør.observe(seksjon);
        });
    }());

    // Toppfeltet krymper når sida scrolles. Selve høyden ligger i CSS-en; her
    // settes bare klassen. Lytteren er passiv og strupet med requestAnimationFrame,
    // så den ikke bremser scrollingen.
    (function () {
        var header = document.querySelector('header.header');
        if (!header) { return; }

        var GRENSE = 60; // px scroll før feltet krymper
        var venter = false;

        function oppdater() {
            venter = false;
            header.classList.toggle('er-krympet', window.pageYOffset > GRENSE);
        }

        window.addEventListener('scroll', function () {
            if (venter) { return; }
            venter = true;
            window.requestAnimationFrame(oppdater);
        }, { passive: true });

        // Langlesing-artiklene kjører GSAP ScrollSmoother, som fanger opp
        // scrollingen selv og aldri slipper gjennom en scroll-hendelse på window.
        // Posisjonen er like fullt riktig, så der driver vi den samme funksjonen
        // fra GSAPs egen ticker i stedet.
        if (window.gsap && window.ScrollSmoother) {
            window.gsap.ticker.add(oppdater);
        }

        oppdater(); // riktig tilstand med en gang, også ved last midt på sida
    }());

    $('[data-toggle-menu]').on("click", function () {
        $("#overlay-nav-menu").toggleClass("is-open");
        // The modal-open class is added via the setTimeout handler below.
    });

    // Menu groups: the parent item only opens/closes its children
    $('#overlay-nav-menu .menu-item-has-children > a')
        .attr('aria-expanded', 'false')
        .on('click', function (e) {
            e.preventDefault();
            var $item = $(this).parent().toggleClass('is-open');
            $(this).attr('aria-expanded', $item.hasClass('is-open') ? 'true' : 'false');
        });

    // Hero: bare filmen som passer skjermen settes opp. JW-biblioteket lastes
    // en gang, og spilleren settes opp med riktig media-ID.
    $('.hero-video-media').each(function () {
        var $media = $(this);
        var spiller = $media.find('.hero-video-spiller')[0];
        var stor = window.matchMedia('(min-width: 40em)').matches;
        // Skjerm og mobil kan ha hver sin spiller, så media- og spiller-ID følges at
        var mediaId = stor ? $media.attr('data-jw-skjerm') : $media.attr('data-jw-mobil');
        var playerId = stor ? $media.attr('data-jw-skjerm-player') : $media.attr('data-jw-mobil-player');

        if (!mediaId) {
            mediaId = $media.attr('data-jw-skjerm') || $media.attr('data-jw-mobil');
            playerId = $media.attr('data-jw-skjerm-player') || $media.attr('data-jw-mobil-player');
        }

        if (!spiller || !playerId || !mediaId) {
            return;
        }

        var settOpp = function () {
            var jw = window.jwplayer(spiller);

            jw.setup({
                playlist: 'https://cdn.jwplayer.com/v2/media/' + mediaId,
                // Filmen fyller høyden CSS-en setter (100svh) i stedet for å
                // følge et fast sideforhold. «fill» beskjærer den til formatet,
                // slik object-fit: cover gjør for en vanlig video.
                width: '100%',
                height: '100%',
                stretching: 'fill',
                autostart: true,   // starter av seg selv
                mute: true,        // må være lydløs for at nettlesere skal tillate autostart
                repeat: true,      // går i loop
                controls: false,   // filmen er en bakgrunn, ikke noe man styrer
                displaytitle: false,
                displaydescription: false
            });

            // Sikkerhetsnett: noen spillerkonfigurasjoner stopper på siste bilde
            // i stedet for å gå i loop
            jw.on('complete', function () {
                jw.play(true);
            });

            // Autostart vurderes én gang, i det spilleren settes opp. Lastes
            // sida i en bakgrunnsfane, er dokumentet skjult da, og JW lar
            // filmen stå — også etter at fanen hentes fram. Uten kontroller
            // har den besøkende ingen måte å starte den på, så vi gjør det
            // selv første gang sida blir synlig.
            if (document.hidden) {
                var start = function () {
                    if (document.hidden) { return; }
                    document.removeEventListener('visibilitychange', start);
                    if (jw.getState() === 'idle') { jw.play(true); }
                };
                document.addEventListener('visibilitychange', start);
            }
        };

        if (window.jwplayer && window.jwplayer.defaults) {
            settOpp();
            return;
        }

        var bibliotek = document.createElement('script');
        bibliotek.src = 'https://cdn.jwplayer.com/libraries/' + playerId + '.js';
        bibliotek.onload = settOpp;
        document.head.appendChild(bibliotek);
    });

    // "Velg din region": nedtrekk på mobil, modal over sida fra medium
    $('[data-region-dropdown]').each(function () {
        var $rot = $(this);
        var $knapp = $rot.find('.region-dropdown-knapp');
        var $panel = $rot.find('.region-dropdown-panel');
        var $innhold = $rot.find('.region-dropdown-innhold');

        var erModal = function () {
            return window.matchMedia('(min-width: 40em)').matches;
        };

        var lukk = function () {
            $panel.attr('hidden', 'hidden');
            $knapp.attr('aria-expanded', 'false');
        };

        $knapp.on('click', function () {
            if ($knapp.attr('aria-expanded') === 'true') {
                lukk();
            } else {
                $panel.removeAttr('hidden');
                $knapp.attr('aria-expanded', 'true');

                // Modalen fyller skjermen og trenger ingen utregning. Det samme
                // gjelder mobil, der lista ligger fast mot skjermbunnen
                // (se _sections.scss).
                $panel.removeClass('oppover').css('max-height', '');
            }
        });

        // Krysset og klikk i det mørke feltet rundt lukker modalen. Klikk inne
        // i selve feltet skal ikke gjøre det.
        $rot.on('click', '[data-region-lukk]', lukk);

        $panel.on('click', function (e) {
            if (erModal() && !$innhold.is(e.target) && $innhold.has(e.target).length === 0) {
                lukk();
            }
        });

        $(document).on('click', function (e) {
            if (!$rot.is(e.target) && $rot.has(e.target).length === 0) {
                lukk();
            }
        });

        $(document).on('keyup', function (e) {
            if (e.key === 'Escape' && $knapp.attr('aria-expanded') === 'true') {
                lukk();
                $knapp.trigger('focus');
            }
        });
    });

    // Lightboks: lenker som peker rett på en bildefil, og som har et bilde i
    // seg, åpnes over sida i stedet for å navigere bort. Mønsteret kommer fra
    // innholdsfeltene — redaktøren setter inn en miniatyr og lenker den til
    // originalen (se f.eks. spørsmålet om veien mot fagbrevet på en fylkeside).
    //
    // Skrevet selv i stedet for et bibliotek: vi skal vise ett bilde og lukke
    // det igjen, og temaet har alt delene fra regionmodalen — mørkt felt,
    // lukkekryss, Escape, og body.modal-open som låser scrollingen bak.
    (function () {
        var BILDE = /\.(jpe?g|png|gif|webp|avif|svg)(\?.*)?$/i;

        var $boks = null;
        var $bilde = null;
        var $tekst = null;
        var $lukkeknapp = null;
        var $åpner = null; // lenka som åpnet, så fokus kan føres tilbake

        function erÅpen() {
            return $boks !== null && $boks.attr('hidden') === undefined;
        }

        function erBildelenke($lenke) {
            return BILDE.test($lenke.attr('href') || '') && $lenke.find('img').length > 0;
        }

        function bygg() {
            $boks = $([
                '<div class="lightboks" role="dialog" aria-modal="true" tabindex="-1" hidden>',
                '<button type="button" class="lightboks-lukk" aria-label="Lukk bildet">&#10005;</button>',
                '<figure class="lightboks-figur">',
                '<img class="lightboks-bilde" src="" alt="">',
                '<figcaption class="lightboks-tekst"></figcaption>',
                '</figure>',
                '</div>'
            ].join('')).appendTo('body');

            $bilde = $boks.find('.lightboks-bilde');
            $tekst = $boks.find('.lightboks-tekst');
            $lukkeknapp = $boks.find('.lightboks-lukk');

            $lukkeknapp.on('click', lukk);

            // Klikk i det mørke feltet lukker. Klikk på selve bildet skal ikke,
            // så bare treff på boksen og figuren rundt teller.
            $boks.on('click', function (e) {
                if (e.target === $boks[0] || e.target === $boks.find('.lightboks-figur')[0]) {
                    lukk();
                }
            });

            // Krysset er det eneste som kan få fokus inni, så tabulator holdes
            // der i stedet for å vandre ut i sida bak.
            $boks.on('keydown', function (e) {
                if (e.key === 'Tab') {
                    e.preventDefault();
                    $lukkeknapp.trigger('focus');
                }
            });
        }

        function åpne($lenke) {
            if (!$boks) {
                bygg();
            }

            // Alt-teksten på miniatyren er bildeteksten. Er den tom, står
            // bildet uten tekst i stedet for med en tom linje under.
            var tekst = $lenke.find('img').first().attr('alt') || '';

            $åpner = $lenke;
            $bilde.attr('src', $lenke.attr('href')).attr('alt', tekst);
            $tekst.text(tekst).toggle(tekst !== '');

            $boks.removeAttr('hidden');
            $('body').addClass('modal-open');

            // Fokus settes på selve boksen, ikke på krysset. Flyttes fokus med
            // skript til en knapp, regner nettleseren den som tastaturfokusert
            // og tegner fokusringen — også for den som nettopp klikket med
            // musa, og da ser ringen ut som en ramme rundt krysset. Boksen har
            // tabindex="-1" for å kunne ta imot fokus, og ingen ring.
            // Tastaturbrukeren kommer til krysset med tabulator, og får ringen
            // der den hører hjemme.
            $boks.trigger('focus');
        }

        function lukk() {
            if (!erÅpen()) {
                return;
            }

            $boks.attr('hidden', 'hidden');
            $('body').removeClass('modal-open');

            // Tømmes, så neste åpning ikke viser forrige bilde et øyeblikk
            // mens det nye lastes.
            $bilde.attr('src', '');

            if ($åpner) {
                $åpner.trigger('focus');
                $åpner = null;
            }
        }

        $(document).on('click', 'a', function (e) {
            // Midtklikk og modifikatorklikk skal fortsatt åpne bildet i egen
            // fane eller lagre det, slik lenker ellers oppfører seg.
            if (e.which !== 1 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
                return;
            }

            var $lenke = $(this);

            if (!erBildelenke($lenke)) {
                return;
            }

            e.preventDefault();
            åpne($lenke);
        });

        $(document).on('keyup', function (e) {
            if (e.key === 'Escape') {
                lukk();
            }
        });

        // Markerer lenkene så de kan få forstørrelsesmarkør. Selve åpningen går
        // via delegering over, så innhold som kommer til senere virker uansett.
        $('a').each(function () {
            var $lenke = $(this);

            if (erBildelenke($lenke)) {
                $lenke.addClass('har-lightboks');
            }
        });
    }());

    // Påmelding til infomøte: knappene åpner ett felles skjema i et overlegg.
    //
    // Fylket er satt i kortkoden på serveren, siden det er likt for hele sida.
    // Sted og tidspunkt skiller møtene, og skrives inn her — ett skjema deles
    // av alle møtene fordi Gravity Forms gir samme element-ID til hver utgave
    // av et skjema, og flere på én side ville kollidert.
    (function () {
        var $overlegg = $('.pamelding-overlegg');

        if (!$overlegg.length) { return; }

        var $innhold = $overlegg.find('.pamelding-innhold');
        var $lukk = $overlegg.find('.pamelding-lukk');
        var $åpner = null;

        // Det Tag Manager får vite om påmeldingen. Verdiene tas vare på her
        // fordi de må leses før innsendingen: etterpå har Gravity Forms byttet
        // ut skjemaet med kvitteringen, og feltene finnes ikke lenger.
        var målt = { sted: '', tid: '', kommune: '' };

        // Kommunen fanges mens den skrives, av samme grunn. Delegert, siden
        // Gravity Forms kan tegne skjemaet på nytt etter en valideringsfeil.
        $overlegg.on('input change', '#input_5_7', function () {
            målt.kommune = $(this).val() || '';
        });

        function erÅpen() {
            return $overlegg.attr('hidden') === undefined;
        }

        function fokuserbare() {
            return $overlegg.find('a[href], button, input, select, textarea')
                .filter(':visible').filter(function () { return !this.disabled; });
        }

        function lukk() {
            if (!erÅpen()) { return; }

            $overlegg.attr('hidden', 'hidden');
            $('body').removeClass('modal-open');

            if ($åpner) { $åpner.trigger('focus'); $åpner = null; }
        }

        $(document).on('click', '[data-pamelding]', function (e) {
            e.preventDefault();

            var $knapp = $(this);

            // Feltene fylles før overlegget vises, så den som melder seg på
            // aldri ser dem endre seg.
            var sted = $knapp.attr('data-sted') || '';
            var tid = $knapp.attr('data-tid') || '';

            $overlegg.find('#input_5_4').val(sted);
            $overlegg.find('#input_5_6').val(tid);

            // Feltene star uten etikett, som resten av skjemaene paa
            // nettstedet. Denne linja forteller hva pameldingen gjelder.
            $overlegg.find('.pamelding-moete').text(
                sted && tid ? sted + ' \u00b7 ' + tid : sted || tid
            );

            målt.sted = sted;
            målt.tid = tid;

            $åpner = $knapp;
            $overlegg.removeAttr('hidden');
            $('body').addClass('modal-open');

            // Fokus på selve overlegget, ikke på første felt: flyttes fokus
            // med skript til et skjemafelt, regner nettleseren det som
            // tastaturfokusert og tegner fokusringen — også for den som
            // nettopp trykte med musa.
            $overlegg.trigger('focus');
        });

        // Krysset i hjoernet, og Lukk-knappen i kvitteringen etter innsending.
        // Delegert, fordi kvitteringen settes inn av Gravity Forms etterpaa.
        $lukk.on('click', lukk);
        $overlegg.on('click', '.pamelding-lukk-knapp', lukk);

        // Etter innsending med ajax bytter Gravity Forms ut skjemaet med
        // kvitteringen. Da flyttes fokus dit, saa skjermleser og tastatur
        // foelger med paa at noe skjedde.
        $(document).on('gform_confirmation_loaded', function (e, skjemaId) {
            if (parseInt(skjemaId, 10) !== 5 || !erÅpen()) { return; }

            // Målingen i Tag Manager henger på denne hendelsen. Skjemaet
            // sendes med ajax, så sida lastes ikke på nytt — mønsteret for
            // interesseskjemaet, der triggeren leser «gf_2» ut av adressa,
            // ville aldri slått til her.
            //
            // Fylket sendes ikke: {{cjsv - Region}} leser det alt ut av
            // adressa. Navn, e-post og telefon skal heller ikke hit —
            // dataLayer deles med hver eneste tagg i containeren, også
            // annonsenettverkene.
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'infomote_pamelding',
                pamelding_sted: målt.sted,
                pamelding_tid: målt.tid,
                pamelding_kommune: målt.kommune
            });

            var $takk = $overlegg.find('.pamelding-takk');

            if ($takk.length) {
                $takk.attr('tabindex', '-1').trigger('focus');
            }
        });

        // Klikk i det mørke feltet rundt lukker. Klikk inne i skjemaet skal ikke.
        $overlegg.on('click', function (e) {
            if (!$innhold.is(e.target) && $innhold.has(e.target).length === 0) { lukk(); }
        });

        $(document).on('keyup', function (e) {
            if (e.key === 'Escape') { lukk(); }
        });

        // Tabulator holdes inne i overlegget, så den som bruker tastatur ikke
        // havner i sida bak mens skjemaet står åpent.
        $overlegg.on('keydown', function (e) {
            if (e.key !== 'Tab') { return; }

            var $felt = fokuserbare();

            if (!$felt.length) { e.preventDefault(); return; }

            var forste = $felt[0];
            var siste = $felt[$felt.length - 1];

            if (e.shiftKey && (document.activeElement === forste || document.activeElement === $overlegg[0])) {
                e.preventDefault();
                siste.focus();
            } else if (!e.shiftKey && document.activeElement === siste) {
                e.preventDefault();
                forste.focus();
            }
        });
    }());

    // Video i seksjon: spill av på stedet, med kontroller og lyd
    $('.video-inline-play').on('click', function () {
        var $knapp = $(this);
        var video = $knapp.closest('.video-inline').find('video')[0];

        if (!video) {
            return;
        }

        video.controls = true;
        video.play();
        $knapp.remove();
    });

    // Historier: "Last inn flere" viser neste pulje som allerede ligger i markup
    $('.historier-last-inn').on('click', function () {
        var $knapp = $(this);
        var $liste = $knapp.closest('.historier').find('.historier-liste');
        var antall = parseInt($liste.attr('data-per-klikk'), 10) || 6;
        var $skjulte = $liste.find('.historie.is-hidden');

        $skjulte.slice(0, antall).removeClass('is-hidden');

        if ($skjulte.length <= antall) {
            $knapp.parent().remove();
        }
    });

    $('.content').click(function () {
        if ($("#overlay-nav-menu").hasClass("is-open")) {
            $("#overlay-nav-menu").removeClass('is-open');
            jQuery('body').removeClass('modal-open'); // Remove modal-open when content is clicked
        }
    });

    $('.infomote').on("click", function () {
        $("#overlay-nav-menu").removeClass('is-open');
        jQuery('body').removeClass('modal-open'); // Also remove modal-open here
    });

    jQuery(document).on('click', '[data-toggle-menu]', function(e) {
        // Wait a few milliseconds so that the menu's state is updated
        setTimeout(function() {
          if (jQuery('#overlay-nav-menu').hasClass('is-open')) {
            jQuery('body').addClass('modal-open');
          } else {
            jQuery('body').removeClass('modal-open');
          }
        }, 10);
    });

});